module.exports = __webpack_public_path__ + "static/media/dom7_4.220ef420.jpg";